<template>
    <my-page title="页面找不到了">
        404
    </my-page>
</template>

<script>
    export default {
        data () {
            return {
            }
        }
    }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/error/Error404.vue